import { restApi } from '../../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate, query } from '../../../../lib/loopback'
import { createQueryString } from '../../../../utils/Repository'

const queryTransform = {
  cpfcnpj: query.ilike('cpfcnpj'),
  ...paginate
}

const transportadorAnttRepository = createRepository({
  path: 'transportadores-antt',
  restApi,
  queryTransform: {
    ...paginate
  }
})

transportadorAnttRepository.manualFetch = ({
  solicitacaoId,
  rntrc,
  placa,
  cpfcnpj
}) =>
  restApi.post(`/transportadores-antt/manual-fetch/${solicitacaoId}`, {
    rntrc,
    placa,
    cpfcnpj
  })

transportadorAnttRepository.list = ({ query, paginate, options } = {}) => {
  const queryString = createQueryString(query, paginate, queryTransform)
  return restApi.get('/transportadores-antt' + queryString, {}, options)
}

export default transportadorAnttRepository
